import { Env } from '../../env';
import { isClub } from '../js_env'

export const getAssetsUrlBase = () => {
    const siteType = Env.SITE_TYPE
    const cdnUrlBase = Env.SETTING.cdn.urlBase
    
    if (isClub(siteType)) {
        return cdnUrlBase + "/assets-club/"
    }
    
    // ソロアリの場合
    return cdnUrlBase + "/assets-soloare/"
}

export const getNoPhotoImageUrl = () => {
    return getAssetsUrlBase() + "images/img_nophoto.jpg"
}